import React, { useState } from 'react'
import './EarningsStyle.css'
import ProfileCard from '../../../components/ProfileCard/ProfileCard'
import ReactApexChart from 'react-apexcharts';
import SearchBar from '../../../components/SearchBar/SearchBar';
import Button from '../../../components/Button/Button';
import { useNavigate } from 'react-router-dom';
import Paginationarrow from '../../../components/Paginationarrow/Paginationarrow';
import Dorpwoncustom from '../../../components/Dorpwoncustom/Dorpwoncustom';

const Earnings = () => {

    const navigate = useNavigate()

    var options2 = {
        chart: {
            toolbar: {
                show: false
            }
        },
        series: [{
            name: "STOCK ABC",
            data: [20, 35, 20, 30, 20, 25, 20, 33, 20]
        }],

        dataLabels: {
            show: false,
            formatter: function (val) {
                return val + "%";
            }
        },

    }

    //dropdown
    const [Dropdownlist, setDropdownlist] = useState();
    const options = [
        {
            label: 'Working Professional',
            value: 'work'
        },
        {
            label: 'Student',
            value: 'student'
        },
    ];

    return (
        <div className="callHIstoryWrap mntablefixEarn">
            <div className="headingwrap flex-between">
                <div>
                    <h2 className='heading-2 mb6'>My Earnings</h2>
                    <p className='text3'>Joined 5 months ago</p>
                </div>
            </div>

            <div className='flex EarningtwoCardWrap'>
                <div className="Allcardboxwrapper MnEarningOverleft">
                    <div className="Adheadingtab">
                        <h3 className='heading-2 mb-6'>Overview</h3>
                        <p className='text3'>Net earnings till date</p>
                    </div>

                    <h3 className='flex earntext'>
                        <img src="/assets/img/rupee.png" alt="" />
                        3200</h3>

                    <div className="AdCardsProfilWrapper flex gap-10 mt-30">
                        <ProfileCard number={'64'} text={'Delivered Solutions'} img={"/assets/img/icons/callyellow.png"} />
                        <ProfileCard className={'purpleCard'} number={'750'} text={'Per Session'} img={"/assets/img/icons/rs.png"} />
                    </div>
                </div>
                <div className="Allcardboxwrapper MnEarningOverright">
                    <div className="Adheadingtab">
                        <h3 className='heading-2 mb-6'>Performance</h3>

                        <div>
                            <ReactApexChart
                                options={options2}
                                series={options2.series}
                                type="area"
                                width="100%"
                                height="190px"

                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className={`callHIstoryWrap AdMnfix`}>
                <div className={`commonTableWrapper ContainerTabForAllTabData  Adcallhsmentor`}>
                    <div className='Headingforallheader'>
                        <h2 className='heading-2'>All Invoices</h2>
                    </div>

                    <div className="border-btm w-100"></div>
                    <div className='bodyDataForallUserdata'>
                        <div className="FaqUserFiltter flex-between">
                            <SearchBar placeholder={'Search here...'} className={'searchbardesign'} />
                            <div className="FilterButtonPast flex gap-10" >
                                <div className='dropdownbtnshow'>
                                    <Dorpwoncustom isActive={Dropdownlist} setIsActive={setDropdownlist} placeholder={'Showing 10 of 32'} options={options} />
                                </div>
                                <label htmlFor="date" className='Cudatedesign'>
                                    <input type="date" id='date' />
                                </label>
                            </div>
                        </div>
                        <div className={`CallHistoryTabledata mt20 fixerninggap`}>

                            <div className="outerdiv">
                                <table>
                                    <thead>
                                        <tr className='headingTabletr'>
                                            <th> <div className="headingtablediv">Invoice No.</div></th>
                                            <th> <div className="headingtablediv">Issued on</div></th>
                                            <th>Description</th>
                                            <th> <div className="headingtablediv">Delivered sessions</div></th>
                                            <th>Amount</th>
                                            <th>Invoice</th>
                                        </tr>

                                    </thead>
                                </table>
                            </div>

                            <div className="innerdiv">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className='tableBox'>
                                                    <h4>#INV0034</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='tableBox'>
                                                    <h4>27/03/2023</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <h4>Executive PGP Interviews</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <h4>2</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <h4 className='lightgreen'>INR 4,000.00</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <span className='downloadspan'>
                                                        <img src="/assets/img/download.png" alt="" className='downloadimg' />
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className='tableBox'>
                                                    <h4>#INV0034</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='tableBox'>
                                                    <h4>27/03/2023</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <h4>Executive PGP Interviews</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <h4>2</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <h4 className='lightgreen'>INR 4,000.00</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <span className='downloadspan'>
                                                        <img src="/assets/img/download.png" alt="" className='downloadimg' />
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className='tableBox'>
                                                    <h4>#INV0034</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='tableBox'>
                                                    <h4>27/03/2023</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <h4>Executive PGP Interviews</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <h4>2</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <h4 className='lightgreen'>INR 4,000.00</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <span className='downloadspan'>
                                                        <img src="/assets/img/download.png" alt="" className='downloadimg' />
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>

                                    </tbody>

                                </table>
                            </div>
                        </div>

                        {/* <div className="lodeemorebutton mt10">
                                <Button name={'Load More'} className={'BlueFillButton buttontext'} />
                            </div> */}
                    </div>
                </div>
            </div>
            {/* <Paginationarrow /> */}
        </div>
    )
}

export default Earnings